import {
  getRouteApi,
  type RegisteredRouter,
  type RouteIds,
  type SearchParamOptions,
} from '@tanstack/react-router'

const cleanEmptyParams = <T extends Record<string, unknown>>(search: T) => {
  return Object.fromEntries(
    Object.entries(search).filter(
      ([, value]) =>
        value !== undefined && value !== '' && !(typeof value === 'number' && Number.isNaN(value))
    )
  ) as T
}

export function useFilters<
  TId extends RouteIds<RegisteredRouter['routeTree']>,
  TSearchParams extends SearchParamOptions<RegisteredRouter, TId, TId>['search'],
>(routeId: TId) {
  const routeApi = getRouteApi<TId>(routeId)
  const navigate = routeApi.useNavigate()
  const filters = routeApi.useSearch()

  const setFilters = (partialFilters: Partial<TSearchParams>) =>
    void navigate({
      search: cleanEmptyParams({
        ...filters,
        ...partialFilters,
      }) as TSearchParams,
    })

  const resetFilters = () => void navigate({ search: {} as TSearchParams })

  return { filters, resetFilters, setFilters }
}
